<script setup>
import AppFooter from "./AppFooter.vue";
import PublicPageHeader from "./PublicPageHeader.vue";

defineProps({
  header: { type: Boolean, default: true },
  footer: { type: Boolean, default: true },
  mainClass: { type: [String, Array, Object], default: "" },
  shellClass: { type: [String, Array, Object], default: "" },
});
</script>

<template>
  <div
    class="app-page-shell bg-[var(--bg-primary)] text-white"
    :class="shellClass"
  >
    <slot v-if="header" name="header">
      <PublicPageHeader />
    </slot>
    <main class="flex min-h-0 flex-1 flex-col" :class="mainClass">
      <slot />
    </main>
    <AppFooter v-if="footer" />
  </div>
</template>
